import React from 'react';
import { connect } from 'react-redux';
import { Handler } from 'ml-component-web';
import EntryHandlerView from './EntryHandlerView';

class EntryHandler extends Handler {
    constructor(props, context) {
        super(props, context, EntryHandlerView);
    }

    renderHandler() {
        return (
            <EntryHandlerView />
        );
    }
}

export default connect()(EntryHandler);



/** WEBPACK FOOTER **
 ** ./src/handler/EntryHandler.js
 **/